export const ORGANIZATION_POLICY_DOCS = {
  privacyPolicy: {
    imageFolder: 'organization-privacy-policy-img',
    navHrefPart: '/organization-details/privacy-policy',
    appPath: '/admin/settings/organization-details/privacy-policy',
    docPath: '/admin/ducumentation/settings/document-organization-details/privacy-policy',
  },
  termsOfUse: {
    imageFolder: 'organization-terms-of-use-img',
    navHrefPart: '/organization-details/terms-of-use',
    appPath: '/admin/settings/organization-details/terms-of-use',
    docPath: '/admin/ducumentation/settings/document-organization-details/terms-of-use',
  },
  cookiePolicy: {
    imageFolder: 'organization-cookie-policy-img',
    navHrefPart: '/organization-details/cookie-policy',
    appPath: '/admin/settings/organization-details/cookie-policy',
    docPath: '/admin/ducumentation/settings/document-organization-details/cookie-policy',
  },
};

export function getOrganizationPolicyKey(pathname) {
  if (pathname.includes('cookie-policy')) return 'cookiePolicy';
  if (pathname.includes('terms-of-use')) return 'termsOfUse';
  return 'privacyPolicy';
}
